import { render, staticRenderFns } from "./PagamentoBancos.vue?vue&type=template&id=4a26d908&"
import script from "./PagamentoBancos.vue?vue&type=script&lang=js&"
export * from "./PagamentoBancos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports